import Vue from 'vue';
import Vuex from 'vuex';
import auth from './auth';
import contents from './contents';

import { DISPLAY_EDIT, OTRS_IS_ACTIVE } from '@/config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    display_edit: DISPLAY_EDIT,
    otrs_is_active: OTRS_IS_ACTIVE,
  },
  modules: {
    auth,
    contents,
  },
});
